<template>
  <div>
    <b-tooltip
      v-if="this.sondage_vue_type_resultats === 'pie'"
      :label="$t('button.PasserEnBar')"
      position="is-left"
    >
        <img
        @click="vueTypeBar"
        style="width:16px;margin-right:10px;cursor:pointer;"
        src="@/assets/img/icons/bar-chart.png"
        alt="full-screen-icon"
      />
    </b-tooltip>
    <b-tooltip
      v-if="this.sondage_vue_type_resultats === 'bar'"
      :label="$t('button.PasserEnPie')"
      position="is-left"
    >
        <img
        @click="vueTypePie"
        style="width:16px;margin-right:10px;cursor:pointer;"
        src="@/assets/img/icons/pie-chart.png"
        alt="full-screen-icon"
      />
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'configure_questions_sondage_name',
      'sondage_name',
      'sondage_vue_resultats',
      'sondage_vue_resultats',
      'sondage_vue_fullscreen',
      'sondage_vue_type_resultats',
      'sondage_barchartRefs',
      'sondage_piechartRefs'
    ])
  },
  methods: {
    ...mapMutations({
      vueSlider: 'SET_VUE_RESULTATS_SLIDER',
      vueTypeBar: 'SET_VUE_TYPE_RESULTAT_BAR',
      vueTypePie: 'SET_VUE_TYPE_RESULTAT_PIE'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/ButtonsPieBar.vue